import Icon from "components/common_components/Icon";

export const getLabel = (id) => statuses[id]?.label || id;

const statuses = {
    todo: {
        label: "To Do",
        category: "default",
        Icon: <Icon name="high-priority" size="sm" />,
    },
    open: {
        label: "Open",
        category: "default",
        Icon: <Icon name="high-priority" size="sm" />,
    },
    reopened: {
        label: "Reopened",
        category: "default",
        Icon: <Icon name="high-priority" size="sm" />,
    },
    inprogress: {
        label: "In Progress",
        category: "info",
        Icon: <Icon name="time-lapse" size="sm" />,
    },
    closed: {
        label: "Closed",
        category: "success",
        Icon: <Icon name="lock" size="sm" />,
    },
    resolved: {
        label: "Resolved",
        category: "success",
        Icon: <Icon name="lock" size="sm" />,
    },
    completed: {
        label: "Completed",
        category: "success",
        Icon: <Icon name="lock" size="sm" />,
    },
    received: {
        label: "Received",
        category: "warning",
        Icon: <Icon name="rounded-check" size="sm" />,
    },
    unreceived: {
        label: "Unreceived",
        category: "warning",
        Icon: <Icon name="high-priority" size="sm" />,
    },
    cancelled: {
        label: "Cancelled",
        category: "error",
        Icon: null,
    },
    rejected: {
        label: "Rejected",
        category: "error",
        Icon: <Icon name="cancel" size="xs" />,
    },
    pending: {
        label: "Pending",
        category: "warning",
        Icon: <Icon name="time-lapse" size="sm" />,
    },
    approved: {
        label: "Approved",
        category: "success",
        Icon: null,
    },
    draft: {
        label: "Draft",
        category: "info",
        Icon: <Icon name="time-lapse" size="sm" />,
    },
    new: {
        label: "NEW",
        category: "warning",
    },
    active: {
        label: "Active",
        category: "success",
    },
    oldVersion: {
        label: "Old Version",
        category: "error",
    },
    currentVersion: {
        label: "Current Version",
        category: "success",
    },
    inactive: {
        label: "Inactive",
        category: "error",
    },
    casePreparation: {
        label: "Case Preparation",
        category: "info",
        Icon: <Icon name="time-lapse" size="sm" />,
    },
    gettingAttorneyReview: {
        label: "Getting Attorney Review",
        category: "warning",
        Icon: <Icon name="time-lapse" size="sm" />,
    },
    used: {
        label: "Used",
        category: "success",
        Icon: <Icon name="rounded-check" size="sm" />,
    },
    expired: {
        label: "Expired",
        category: "error",
        Icon: <Icon name="cancel" size="xs" />,
    },
    // Campaign statuses (backend CampaignStatus enum, serialized in uppercase).
    CREATED: {
        label: "Created",
        category: "info",
        Icon: <Icon name="draft" size="sm" />,
    },
    ACTIVE: {
        label: "Active",
        category: "success",
        Icon: <Icon name="rounded-check" size="sm" />,
    },
    INACTIVE: {
        label: "Inactive",
        category: "warning",
        Icon: <Icon name="high-priority" size="sm" />,
    },
    FINISHED: {
        label: "Finished",
        category: "default",
        Icon: <Icon name="lock" size="sm" />,
    },
};

export default statuses;
